import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import AdModal from "../ads/AdModal";

function MessageBoxReader() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAdModal, setShowAdModal] = useState(false);
  const [selectedAd, setSelectedAd] = useState(null);
  const [adType, setAdType] = useState("tutor"); // or "student"
  const { t } = useTranslation();
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/message_box.php`, {
        withCredentials: true,
        headers: { Authorization: `Bearer ${auth.token}` },
      })
      .then((res) => {
        if (res.data.success) {
          setMessages(res.data.messages);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [auth.token]);

  const handleRead = async (msg) => {
    await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/message_box.php`,
      {
        id: msg.id,
        action: "markAsRead",
      },
      {
        withCredentials: true,
        headers: { Authorization: `Bearer ${auth.token}` },
      }
    );
    // Show ad modal if comment_id exists
    if (msg.ad_id) {
      try {
        if (msg.ad_id) {
          const adRes = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/ads.php`,
            {
              params: { id: msg.ad_id },
              withCredentials: true,
              headers: { Authorization: `Bearer ${auth.token}` },
            }
          );
          if (adRes.data.success && adRes.data.ad) {
            setSelectedAd(adRes.data.ad);
            setAdType(adRes.data.ad.adType || "tutor");
            setShowAdModal(true);
          }
        }
      } catch (e) {
        // fallback: do nothing or show error
      }
    }
  };

  const handleCloseAdModal = () => {
    setShowAdModal(false);
    setSelectedAd(null);
  };

  return (
    <div className="p-4 bg-slate-50 rounded-lg">
      <div className=" p-4">
        <h2 className="text-xl font-bold mb-4">{t("messageNotification")}</h2>
        <ul className="space-y-2">
          {messages.map((msg) => (
            <li
              key={msg.id}
              className={`p-3 rounded shadow flex justify-between items-center ${
                msg.is_read ? "bg-gray-100" : "bg-yellow-50"
              }`}
            >
              <span>{msg.content}</span>
              <button
                className="ml-4 px-3 py-1 bg-blue-500 text-white rounded"
                onClick={() => handleRead(msg)}
              >
                {msg.is_read ? t("read") : t("view")}
              </button>
            </li>
          ))}
        </ul>
      </div>
      {loading && <div className="text-sm text-slate-500">{t("loading")}</div>}
      {!loading && !messages.length && <div>{t("noMessages")}</div>}

      {/* Ad modal for viewing ad info */}
      <AdModal
        show={showAdModal}
        ad={selectedAd}
        onClose={handleCloseAdModal}
        user={auth.user}
        token={auth.token}
        t={t}
        type={adType}
      />
    </div>
  );
}

export default MessageBoxReader;
